export { default } from './MandatesTable';
export { TableRow } from './components/MandatesTableRow';
